import { render, staticRenderFns } from "./redeem-form.vue?vue&type=template&id=718c4233&"
import script from "./redeem-form.vue?vue&type=script&lang=js&"
export * from "./redeem-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports